__turbopack_context__.v({
  "nmi-address-select": "A_MtLq_nmi-address-select",
  "nmi-address-select__body": "A_MtLq_nmi-address-select__body",
  "nmi-address-select__card": "A_MtLq_nmi-address-select__card",
  "nmi-address-select__card-header": "A_MtLq_nmi-address-select__card-header",
  "nmi-address-select__card-heading": "A_MtLq_nmi-address-select__card-heading",
  "nmi-address-select__form-wrap": "A_MtLq_nmi-address-select__form-wrap",
  "nmi-address-select__heading": "A_MtLq_nmi-address-select__heading",
  "nmi-address-select__info": "A_MtLq_nmi-address-select__info",
  "nmi-address-select__intro": "A_MtLq_nmi-address-select__intro",
  "nmi-address-select__nmi": "A_MtLq_nmi-address-select__nmi",
  "nmi-address-select__nmi-header": "A_MtLq_nmi-address-select__nmi-header",
  "nmi-address-select__nmi-label": "A_MtLq_nmi-address-select__nmi-label",
  "nmi-address-select__radio-group": "A_MtLq_nmi-address-select__radio-group",
  "nmi-address-select__radio-group-label": "A_MtLq_nmi-address-select__radio-group-label",
  "nmi-address-select__radio-group-option": "A_MtLq_nmi-address-select__radio-group-option",
  "nmi-address-select__submit": "A_MtLq_nmi-address-select__submit",
  "nmi-address-select__tips": "A_MtLq_nmi-address-select__tips",
  "nmi-address-select__tips-heading": "A_MtLq_nmi-address-select__tips-heading",
  "nmi-address-select__tips-list": "A_MtLq_nmi-address-select__tips-list",
});
